<script>
    import {Pie, mixins} from 'vue-chartjs'
    import ChartJsPluginDataLabels from 'chartjs-plugin-labels';

    const {reactiveProp} = mixins

    export default {
        extends: Pie,
        mixins: [reactiveProp],
        components: {
            ChartJsPluginDataLabels
        },
        data: () => ({
            initChartdata: null
        }),
        props: {
            chartData: {
                type: Object,
                default: null
            },
            hideIndex: {
                type: Number,
                default: null
            }
        },
        //Kijken als chart geupdate wordt, ook de legende aanpassen
        watch: {
            chartData() {
                const HTML = this.$data._chart.generateLegend()
                this.$emit('generated', HTML)
            },
            hideIndex(){
                let dataset = this.chartData.datasets[0].data[this.hideIndex]

                if(dataset){
                    this.chartData.datasets[0].data[this.hideIndex] = 0
                }else{
                    this.chartData.datasets[0].data[this.hideIndex] = this.prev[0].data[this.hideIndex]
                }
                this.hideIndex = null

                this.functionChart()
            }
        },
        mounted() {
            this.functionChart()
            const HTML = this.$data._chart.generateLegend()
            this.$emit('generated', HTML)

            //Init chartdata voor terug showen van slice
            this.initChartdata =  this.$_.cloneDeep(this.$store.state.chart.packetDistribution.datasets)
        },
        methods: {
            //Custom legend click, hide/show slice
            changeSlice(index){
                let dataset = this.chartData.datasets[0].data[index]

                if(dataset){
                    this.chartData.datasets[0].data[index] = 0
                }else{
                    this.chartData.datasets[0].data[index] = this.initChartdata[0].data[index]
                }
                this.functionChart()
            },
            functionChart: function() {
                this.renderChart(this.chartData, {
                    legend: {
                        display: false
                    },
                    legendCallback: function (chart) {
                        var legendHtml = [];
                        var item = chart.data.datasets[0];
                        for (var i = 0; i < item.data.length; i++) {
                            legendHtml.push({
                                label: chart.data.labels[i],
                                data: item.data[i],
                                color: item.backgroundColor[i],
                                datasetindex: chart.chart.legend.legendItems[i].index
                            })
                        }
                        return legendHtml
                    },
                    plugins: {
                        labels: {
                            render: 'value',
                            fontColor: 'black'
                        }
                    },
                    onClick: this.handle
                })
            },
            handle(point, event) {
                //Enkel als er op de chart zelf geklikt wordt call doen, niet bij legende
                if (event.length) {
                    this.$store.dispatch('CALL_CHART_MODAL_DATA', {
                        chart: 'packet-distribution',
                        chart_item: event[0]._model.label,
                        chart_title: 'Lead source distribution - ' + event[0]._model.label
                    })
                }
            }
        }
    }
</script>
<style>
    .chart-legend {
        width: 37px;
        height: 12px;
        display: inline-block;
    }

    .chart-legend-label-text {
        padding: 0 5px;
        font-size: 12px;
        cursor: default;
    }

    .chart-legend-container {
        line-height: 1 !important;
    }

    .line-trough{
        text-decoration: line-through;
    }
</style>
